import React from "react";

const Error404: React.FC = () => {
  return <div>Error 404</div>;
};

export default Error404;
